import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Form, FormElement, FormElementValidators } from 'src/common/form';
import { Auth, AuthenticationModel, AuthenticateUser } from 'src/common/security';
import { TranslationManager } from 'src/common/translation';
import { MessagesComponent } from 'src/common/components';
import { SupplierUserBasicModel } from 'src/common';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    form: Form = new Form();
    error: string;
    translationManager = TranslationManager;
    dataUser: any;
    showRoles = false;
    isForgetPasswordEnabled: boolean = false;
    notFirstLoginUsers: SupplierUserBasicModel[] = [];


    updateForgetPasswordButton(): void {
        const usernameValue = this.form.elements['username'].value;

        this.isForgetPasswordEnabled = this.notFirstLoginUsers.some(user => user.username === usernameValue);
    }

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.initForm();
        Auth.getNotFirstLoginUsers().then((result: SupplierUserBasicModel[]) => {
            this.notFirstLoginUsers = result;
        });
    }

    login() {

        this.error = undefined;

        if (this.form.isValid()) {
            var email = this.form.elements['username'].value;
            var password = this.form.elements['password'].value;

            let model: AuthenticationModel = new AuthenticationModel();
            model.username = email;
            model.password = password;

            Auth.Login(model).then((data) => {
                Auth.getAuthenticatedUser();
            }).catch((e: any) => {
                this.error = e.error.messages;
                MessagesComponent.instance.showError([this.error]);
            });
        }
    }

    LogInWithRole(id: number) {
        let user = new AuthenticateUser();
        user.userId = this.dataUser.id;
        user.roleId = id.toString();
        Auth.authenticate(user).then(() => {
            this.router.navigate(['/home']);
        }).catch((e: any) => {
            this.error = e.error.messages;
            MessagesComponent.instance.showError([this.error]);
        });
    }

    forgetPassword() {
        this.router.navigate(['/forget-password']);
    }

    private initForm() {
        this.form.elements['username'] = new FormElement();
        this.form.elements['username'].state.mandatory = true;
        this.form.elements['username'].onValidation = FormElementValidators.stringValidator;

        this.form.elements['password'] = new FormElement();
        this.form.elements['password'].state.mandatory = true;
        this.form.elements['password'].onValidation = FormElementValidators.stringValidator;
    }
}
